module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ListView__container"
  }, [_c('ThePage', {
    attrs: {
      "class-name": 'ListView',
      "title": 'LIST__LIST'
    }
  }, [_c('template', {
    slot: "left-action"
  }, [_c('BaseNavigationButton', {
    attrs: {
      "icon": 'icon-left'
    },
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "right-action"
  }, [_c('BaseNavigationButton', {
    attrs: {
      "label": 'LIST__ADD',
      "icon": 'icon-plus'
    },
    on: {
      "click": function($event) {
        _vm.open()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }],
    staticClass: "ListView__body"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('ListItem', {
      key: item.id,
      attrs: {
        "name": item.name,
        "sex": item.sex
      },
      on: {
        "click": function($event) {
          _vm.open(item.id)
        }
      }
    })
  })), _vm._v(" "), _c('BaseLoader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoaded),
      expression: "!isLoaded"
    }]
  })], 2), _vm._v(" "), (_vm.listItemVisible) ? _c('ListItemModal') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28c0b048"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ListView.vue
// module id = 575
// module chunks = 1